import { useCallback, useState } from 'react';

import { ChatMessageCreateFileModalData } from '../../data/data/types';

const useCreateChatFileModal = () => {
  const [createChatFileModalData, setCreateChatFileModalData] =
    useState<ChatMessageCreateFileModalData | null>(null);
  const showCreateChatFileModal = useCallback(
    (value: ChatMessageCreateFileModalData | null) => {
      setCreateChatFileModalData(
        value
          ? {
              onClose: () => {
                setCreateChatFileModalData(null);
              },
              ...value,
            }
          : null
      );
    },
    []
  );
  return { createChatFileModalData, showCreateChatFileModal };
};

export { useCreateChatFileModal };
